import Swiper from 'swiper/swiper-bundle';

export const imageSlider = () => {

	const swiperImageSliderFW = new Swiper('.js-init-image-swiper--full-width-image', {
        slidesPerView: "auto",
        autoplay: false,
        loop: false,
        spaceBetween: 24,
        slidesPerView: 1,
        pagination: {
	        el: '.swiper-pagination',
	        type: 'bullets',
	        clickable: true
	    },
	    navigation: {
            nextEl: '.swiper-arrow--next',
            prevEl: '.swiper-arrow--prev',
        },
    });

    const swiperImageSliderIG = new Swiper('.js-init-image-swiper--image-grid', {
        slidesPerView: "auto",
        autoplay: true,
        loop: true,
        breakpoints: {
            390: {
              slidesPerView: 1,
              spaceBetween: 16,
            },
            768: {
              slidesPerView: 4,
              spaceBetween: 24,
            },
        },
    });
}

imageSlider();